/* eslint-disable no-console */
import { Modal, Box, Typography, Grid2, TextField, Button } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Modals.module.css';
import { createTest, TestRequest } from './helper.stim';
import { useAlert } from '../../components/alertProvider';
import { formatDateToLocalYYYYMMDD } from '../../services/time';
import {ReactComponent as WarningCircle} from '../../assets/SVG/Warning.svg';
interface HormoneValueModalProps {
    hormonesModalOpen: boolean,
    handleHormonesModalClose: () => void,
    hormoneId?: number,
    patientId: number,
    date?: Date,
    cycle: number,
    id?: number,
    value?: string,
    selected_stim: number,
    unit?: string
}

const HormoneValueModal: React.FC<HormoneValueModalProps> = ({hormonesModalOpen, handleHormonesModalClose, patientId, date, hormoneId, value, id, selected_stim, unit}) => {
  const { t } = useTranslation('stimulation_config');
  const {addAlert} = useAlert();
  const updatedValue = value? value === '+'? '': value: '';
  const [hormonesFormData, setHormonesFormData] = useState({
    hormoneValue: updatedValue || '',
  });
 
  const handleHormonesChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    
    const { name, value } = event.target;
    setHormonesFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleHormonesSubmit = () => {
    if (hormoneId && date) {
      const body: TestRequest = {
        patient: patientId,
        laboratory_test: hormoneId,
        results: parseInt(hormonesFormData.hormoneValue),
        date: formatDateToLocalYYYYMMDD(date),
        stim_chart: selected_stim
      };

      createTest(body, id)
        .then(() => {
          if (id) {
            addAlert(t('HormoneUpdatedSuccessfully'), 'success');
          } else {
            addAlert(t('HormoneTestCreatedSuccessfully'), 'success');
          }
        })
        .catch(() => addAlert(id ? t('FailedToUpdateHormoneTest') : t('FailedToCreateHormoneTest'), 'error'));
    }
    handleHormonesModalClose();
  };
      
  return (
    <Modal open={hormonesModalOpen} onClose={handleHormonesModalClose} >
      <Box className={`${styles.modal} ${styles.modalSmall}`} p={1}>
        {id && <Box className={styles.modalHeader}>
          <Typography variant="h3" gutterBottom>
            {t('AddResult')}
          </Typography>
        </Box>}
        <Grid2 container spacing={2} className={styles.modalBody} justifyContent={id ? 'flex-start': 'center'}>          
          {id ? 
            <>
              <Grid2 size={{xs:12, md:6 }}>
                <TextField
                  fullWidth
                  label={<>
                    {t('HormoneValue')} <span style={{ color: 'red' }}> * </span>
                  </>}
                  name="hormoneValue"
                  placeholder={t('HormoneValue')}
                  value={hormonesFormData.hormoneValue}
                  onChange={handleHormonesChange}
                  margin="normal"
                  slotProps={{inputLabel:{shrink: true}}}
                />
              </Grid2>
              {unit && (
                <Grid2 size={{xs:12, md:6 }}>
                  <TextField
                    fullWidth
                    label={t('Unit')}
                    value={unit}
                    margin="normal"
                    disabled
                    slotProps={{inputLabel:{shrink: true}}}
                    sx={(theme) => ({
                      '& .MuiInputBase-root.Mui-disabled': {
                        backgroundColor: theme.palette.action.disabledBackground,
                      },
                      '& .MuiInputBase-input.Mui-disabled': {
                        color: theme.palette.text.secondary,
                        WebkitTextFillColor: theme.palette.text.secondary,
                        opacity: 1,
                      },
                    })}
                  />
                </Grid2>
              )}
            </> : 
            <Box display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'} mb={2}>
              <WarningCircle style={{width: '3rem', height: '3rem'}}/>
              <Typography id="modal-hormones-title" variant="h5" component="p" color='primary.main' fontWeight={500} mt={3} mb={1}>
                {t('Hormones')}
              </Typography>
              <Typography>{t('AreYouSureYouWantToScheduleHormoneTest')}</Typography>
            </Box>
          }          
        </Grid2>
        <Box className={styles.primary}>
          <Button fullWidth variant="outlined" onClick={handleHormonesModalClose} className={styles.modalCancelBtn}>
            {id ? t('Cancel'): t('No')}
          </Button>
          <Button fullWidth variant="contained" onClick={handleHormonesSubmit} className={styles.modalSaveBtn}>
            {id ? t('Update'): t('Yes')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default HormoneValueModal;